import { CustomerReviewAdvice, trackAddToPageImpression } from './track-add-to-page-impression';
import { getReviewSubmissionClientData } from '../helper/get-review-submission-client-data';
import { addNonPdpFeaturesToPageImpression } from '../../../_common/client/tracking/add-non-pdp-features-to-page-impression';
import { ReviewSubmissionStatus } from '../../../_common/types/customer-review/review-submission-data';

type TrackComponentInitParams = {
    rootElement: Pick<HTMLElement, 'dataset'>;
};
export const trackComponentInit = ({ rootElement }: TrackComponentInitParams) => {
    const reviewSubmissionClientData = getReviewSubmissionClientData({ rootElement });
    const customerReviewAdvice = mapReviewSubmissionStatusToTrackingCustomerReviewAdvice(reviewSubmissionClientData.status);

    switch (reviewSubmissionClientData.status) {
        case 'CAN_SUBMIT': {
            const availableIdentifiers = (reviewSubmissionClientData.livingSpecificNumericRatings ?? []).map(rating => rating.identifier);
            trackAddToPageImpression({
                customerReviewAdvice,
                assembly: availableIdentifiers.includes('assembly'),
                comfort: availableIdentifiers.includes('comfort'),
                productDesign: availableIdentifiers.includes('design_appearance'),
                productQuality: true,
                productFit: reviewSubmissionClientData.showFitRating,
                source: reviewSubmissionClientData.reviewSource,
                valueForMoney: availableIdentifiers.includes('price_performance_ratio'),
                variationId: reviewSubmissionClientData.variation.id,
            });
            addNonPdpFeaturesToPageImpression(reviewSubmissionClientData.variation.id);
            break;
        }
        default: {
            trackAddToPageImpression({
                customerReviewAdvice,
                source: reviewSubmissionClientData.reviewSource,
                variationId: reviewSubmissionClientData.variationId,
            });
            addNonPdpFeaturesToPageImpression(reviewSubmissionClientData.variationId);
            break;
        }
    }
};

const mapReviewSubmissionStatusToTrackingCustomerReviewAdvice = (status: ReviewSubmissionStatus): CustomerReviewAdvice | undefined => {
    switch (status) {
        case 'NOT_VERIFIED':
            return 'not_verified';
        case 'SUBMISSION_CURRENTLY_NOT_POSSIBLE':
            return 'currently_not_possible';
        case 'REVIEW_ALREADY_SUBMITTED':
            return 'double_review';
        default:
            return undefined;
    }
};
